
module.config(function($stateProvider) {

    $stateProvider.state('program.info.details', {
        url: '',
        permission: 'view',
        templateUrl: 'programs/info/details',
        resolve: {
            addresses: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'addresses');
            },
            websites: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'websites');
            },
            details: function(program, ModelService) {
                return ModelService.get('program', program.id);
            },
            log: function(program, LogInfo) { 
                var log = new LogInfo(program, "info");
                return log.load();
            }
        },
        controller: 'ProgramEditController',
    });
});
